export default __webpack_public_path__ + "static/6-af03ac72fa9400e4f3bcbe8317b811b0.jpg";